<template>
  <div>
    <div class="images"
         v-viewer="{movable: false}">
      <img :src="imageSrc">
    </div>
    <div v-show="!loading"
         style="width: 960px">
      <div :ref="'div' + i"
           v-for="i in totalPageCount"
           :key="i">
        <canvas :ref="'canvas' + i"
                @click="handleClickCanvas"></canvas>
      </div>
    </div>
    <div v-show="loading"
         style="width: 960px; text-align: center">
      <div style="width: 100%; margin-top: 48px; display: flex; justify-content: center; align-items: center">
        <Spin size="large"></Spin>
      </div>
    </div>
  </div>
</template>

<script>
import pdfjsLib from 'pdfjs-dist'
import _ from 'lodash'
export default {
  name: 'pdf-preview',
  components: {},
  props: {
    url: {
      type: String,
      default: undefined
    },
    password: {
      default: 'Zailairen19'
    }
  },
  data () {
    return {
      totalPageCount: 0,
      showModal: false,
      updateCallback: undefined,
      loading: false,
      timeOutName: '',
      imageSrc: '',
      debounce: ''
    }
  },
  watch: {
    url (newValue) {
      console.log(newValue)
      if (!newValue) {
        return false
      }
      this.renderPdf()
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (!this.url) return false
      this.renderPdf()
      this.debounce = _.debounce(this.handleScale, 800)
    })
  },
  methods: {
    renderPdf () {
      this.loading = true
      let dom = this.$refs
      let loadingTask = pdfjsLib.getDocument(this.url)
      loadingTask.onPassword = (updateCallback, reason) => {
        updateCallback(this.password)
      }
      loadingTask.promise.then(pdf => {
        this.totalPageCount = pdf.numPages
        for (let i = 1; i <= pdf.numPages; i++) {
          pdf.getPage(i).then(function (page) {
            var desiredWidth = 960
            var scale = desiredWidth / page.getViewport({ scale: 1 }).width
            let viewport = page.getViewport({ scale: scale })
            if (!dom['canvas' + i] || !dom['canvas' + i][0]) return false
            let canvas = dom['canvas' + i][0]
            let context = canvas.getContext('2d')
            canvas.height = viewport.height
            canvas.width = viewport.width
            let renderContext = {
              canvasContext: context,
              viewport: viewport
            }
            page.render(renderContext)
          })
        }
        this.loading = false
      })
    },
    handleClickCanvas (canvas) {
      this.imageSrc = canvas.target.toDataURL('image/png')
      this.debounce()
    },
    handleScale () {
      const viewer = this.$el.querySelector('.images').$viewer
      viewer.show()
    }
  }
}
</script>

<style scoped>
.images {
  display: none;
}
</style>
